import React from 'react';
import { Form, Select } from 'antd';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

export const ReportNameSelect = () => {
  const { t } = useTranslation();

  const reportNames = useSelector((state) => state.reportSummaryDictionaries.reportNames);
  const reportTitleOptions = reportNames.map((item) => ({
    label: item.name,
    value: item.id,
  }));

  return (
    <Form.Item
      name='reportKindId'
      rules={[{ required: true, message: t('error.requiredField') }]}
    >
      <Select placeholder={t('governmentServiceEducation.reportSummaryTitle')} options={reportTitleOptions} />
    </Form.Item>
  );
};